import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysRecommendationsRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [dashboardData, recommendations] = await Promise.all([
      this.reimaginedData.fetchDashboardData(),
      this.reimaginedData.fetchRecommendations(),
    ]);

    return {
      recommendations,
      employee: dashboardData.employee,
      careerPlan: dashboardData.careerPlan,
      summary: dashboardData.summary,
    };
  }
}
